import React from "react";

export const RotateHorizontal = React.forwardRef<SVGSVGElement, React.SVGAttributes<SVGElement>>((props, ref) => {
	return (
		<svg
			ref={ref}
			width="220"
			height="220"
			viewBox="0 0 220 220"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M32.5 176.5V154.5" stroke="black" strokeWidth="5" strokeLinecap="round" />
			<path d="M154.5 21.5L132.5 21.5" stroke="#A6A6A6" strokeWidth="5" strokeLinecap="round" />
			<path
				d="M194.5 126.5V96.1255V24.5C194.5 14.0066 185.993 5.5 175.5 5.5L111.5 5.5C101.007 5.5 92.5 14.0066 92.5 24.5L92.5 96.1255V115.566"
				stroke="#A6A6A6"
				strokeWidth="6"
			/>
			<rect
				x="19"
				y="214"
				width="97"
				height="177"
				rx="16.5"
				transform="rotate(-90 19 214)"
				stroke="black"
				strokeWidth="5"
			/>
			<path
				d="M72.0047 43.9424C73.3854 43.9455 74.5022 45.0674 74.499 46.4481C74.4959 47.8288 73.3741 48.9455 71.9933 48.9424L72.0047 43.9424ZM71.9933 48.9424L56.7566 48.9078L56.768 43.9078L72.0047 43.9424L71.9933 48.9424ZM47.2351 58.3862L47.1799 82.6967L42.1799 82.6853L42.2351 58.3748L47.2351 58.3862ZM56.7566 48.9078C51.5099 48.8959 47.247 53.1395 47.2351 58.3862L42.2351 58.3748C42.2533 50.3667 48.7599 43.8896 56.768 43.9078L56.7566 48.9078Z"
				fill="#0088E9"
			/>
			<path
				d="M59.7471 71.6201L44.4008 85.4721L29.7485 71.3294"
				stroke="#0088E9"
				strokeWidth="5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
});
RotateHorizontal.displayName = "RotateHorizontal";
